import React from 'react';
import { FormControl, FormLabel, Box, IconButton, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';

const FileField = ({ label, value, onChange, onRemove, disabled, tfid }) => {
  return (
    <FormControl
      component="fieldset"
      margin='normal'
      disabled={disabled}
      sx={{ width: "100%" }}
    >
      <FormLabel component="legend" sx={{
        color: "#c1cddb",

        ...(disabled && {
          color: "#a7bbcf !important",
        })
      }}>{label}
      </FormLabel>

      <Box sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        marginTop: "4px",
      }}>
        <input
          type="file"
          onChange={(e) => onChange(e.target.files[0])}
          disabled={disabled}
          style={{
            display: "none",
          }}
          id={`file-input-${tfid}`}
        />
        <label htmlFor={`file-input-${tfid}`}>
          <IconButton
            component="span"
            disabled={disabled}
            sx={{
              color: "#c1cddb",
              ...(disabled && {
                color: "gray !important",
              })
            }}
          >
            <CloudUploadIcon sx={{ fontSize: 28 }} />
          </IconButton>
        </label>

        <Typography
          variant="body2"
          sx={{
            color: "#919aa3",
            flexGrow: 1,
          }}
        >
          {value ? value.name : "No file chosen"}
        </Typography>

        {value && !disabled && (
          <IconButton
            onClick={onRemove}
            size='small'
            sx={{
              color: "#c1cddb",
            }}
          >
            <DeleteIcon sx={{ fontSize: 20 }} />
          </IconButton>
        )}
      </Box>
    </FormControl>
  );
};

export default FileField;